import React from 'react';
import "./PendingNote.scss";
import { getIcon } from '../../utils/images';

const PendingNote = ({ collapse }) => {
  return (
    <div className='PendingNote'>
      <img src={getIcon('note')} />
      <div>
        {
          collapse
            ? "No shipment details received from the carrier at the moment."
            : "No shipment details received from the carrier at the moment. It will be updated once any future updates received from the carrier."
        }
      </div>
    </div>
  )
};

export default PendingNote;